// The action endpoints create one record per request, so every file has to go
// in a single request. api.riskhub's PHP drops files past max_file_uploads (20)
// and the whole body past post_max_size (500M in the deployed image). The total
// has to stay under the body limit of the API this build talks to, which is
// lower locally (env.local's nginx allows 25m).
export const MAX_FILES_PER_REQUEST = 20;
export const MAX_TOTAL_UPLOAD_MB = Number(process.env.VUE_APP_MAX_TOTAL_UPLOAD_MB) || 480;

const TOTAL_UPLOAD_SIZE_ERROR = `The files can't be larger than ${MAX_TOTAL_UPLOAD_MB} MB in total.`;

export const singleRequestUploadOptions = {
  parallelUploads: MAX_FILES_PER_REQUEST,
  maxFiles: MAX_FILES_PER_REQUEST,
  dictMaxFilesExceeded: 'You can attach up to {{maxFiles}} files at once.',
  // Dropzone 5.5 sets no ontimeout handler, so a timed-out upload never errors
  // or completes and the modal spins forever.
  timeout: 0,
  // Dropzone calls this with itself as `this`, before it counts `file` as accepted.
  accept(file, done) {
    const acceptedBytes = this.getAcceptedFiles().reduce((sum, accepted) => sum + accepted.size, 0);

    if (acceptedBytes + file.size > MAX_TOTAL_UPLOAD_MB * 1024 * 1024) {
      done(TOTAL_UPLOAD_SIZE_ERROR);

      return;
    }

    done();
  },
};
